define('models/lead',['require','backbone','models/country','models/city','models/phone_number','models/customer','models/reseller','models/distributor','models/country_distributor','models/state'],function(require){

    var Backbone = require('backbone');

    var CountryModel = require('models/country');
    var CityModel = require('models/city');
    var PhoneNumberModel = require('models/phone_number');
    var CustomerModel = require('models/customer');
    var ResellerModel = require('models/reseller');
    var DistributorModel = require('models/distributor');
    var CDModel = require('models/country_distributor');
    var StateModel = require('models/state');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'leads/' + this.id + '/' ) :
                ( App.Config.apiBase + 'leads/' );
        },


        defaults: function () {
            return {
                id: null,
                name: '',
                contact_name: '',
                phone_number: new PhoneNumberModel().attributes,
                phone_country: null,
                phone_value: '',
                country: null,
                city_name: '',
                current_pos: null,
                source: null,
                district: '',
                address: '',
                contact_email: '',
                contact_phone_number: new PhoneNumberModel().attributes,
                contact_phone_country: null,
                contact_phone_value: '',
                status: 1,
                progress_status: null,
                distributor_object: new DistributorModel().attributes,
                reseller_object: new ResellerModel().attributes,
                customer_object: new CustomerModel().attributes,
                city_object: new CityModel().attributes,
                country_object: new CountryModel().attributes,
                resellers: [],
                distributors: [],
                cd_object: new CDModel().attributes,
                state: null,
                state_object: new StateModel().attributes,
            };
        }
    });
});
